import _ from 'lodash'
import { dataSuperTypesById } from './edit/fields/data-super-types'
import DataType from 'scoreboard/datasets/model/data-type'
const { ROLLUP } = DataType

function isGeographicOrRollup(dataType) {
	return dataType == ROLLUP ||
		_.includes(dataSuperTypesById['geographic'].dataTypes, dataType)
}

export default isGeographicOrRollup

isGeographicOrRollup.__filename__ = 'datasets/is-geographic-or-rollup.js'
